
export default {
	name: "NYTStrandsCard",
	props: {
		borderColor: {
			type: String,
			required: false,
			default: "#F8CC2C",
		},
		innerClass: {
			type: String,
			required: false,
			default: "",
		},
	},
};
